import { API_CHAT_URL } from 'consts/common.const';
import { Http } from 'services/http';
import { IConversation } from 'types/chat/conversation';

export const getConversations = () => {
  return Http.request<IConversation[]>({
    method: 'GET',
    url: `${API_CHAT_URL}/conversation`,
  });
};
